import styled from '@emotion/styled'

export const Overlay = styled.section`
  display: flex;
  position: fixed;
  margin: 0;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #0000004d;
  z-index: 2147483601;
`
